module.exports = __webpack_public_path__ + "img/setor_recursos_humanos.2b718f18.png";